// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SideContentsArea[data-v-615ad81e]{z-index:100}.toggle-slide-enter-active[data-v-615ad81e],.toggle-slide-leave-active[data-v-615ad81e]{transition:all .5s;overflow:hidden}.toggle-slide-enter[data-v-615ad81e],.toggle-slide-leave-to[data-v-615ad81e]{height:0;transition:all .5s}", ""]);
// Exports
module.exports = exports;
